import searchActions from './search';

export default {
    ...searchActions,
};
